module.exports = __webpack_public_path__ + "static/media/529FB1FC-02CF-4EB3-B95C-43BCD6DD8AB9-min.5beed59e.jpg";